import React, { useState } from "react";

const PolicyCommitments = () => {
  const [currentPage, setCurrentPage] = useState(0);
  const [selectedFile, setSelectedFile] = useState(null);
  const [formData, setFormData] = useState({
    legalForm: "",
    natureofOwnership: "",
    headquarters: "",
    countriesOfOperation: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  //   Page buttons
  const handlePrevious = () => {
    setCurrentPage(currentPage - 1);
    window.scrollTo(0, 0);
  };

  const handleNext = () => {
    setCurrentPage(currentPage + 1);
    window.scrollTo(0, 0);
  };

  // form contents
  const handleFileChange = (e) => {
    setSelectedFile(e.target.files[0]);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission or file upload logic here
  };

  return (
    <div className="container mx-auto">
      {/* <h1 className="mx-4 pt-4 font-semibold">2.1</h1> */}
      <div className="flex justify-between">
        <h1 className="mx-4 pb-8 text-gray-500 text-xl font-bold">
          Policy Commitments
        </h1>
        <h3 className="text-end mx-8 w-[7%] bg-gray-200 font-bold text-sm h-[3%] w-[80px] border-4 h-12 ">
          GRI 2-23
        </h3>
      </div>
      <form onSubmit={handleSubmit}>
        <div className="flex items-center mx-4 pb-2 mb-4">
          <div className="w-full mr-2">
            <label htmlFor="legalForm" className="block font-bold mb-1 pb-4">
              <h2 className="text-gray-600">
                Describe the organization's policy commitments for responsible
                business conduct, including
              </h2>
            </label>

            <div className="flex items-center mx-4 pb-2 mb-4">
              <div className="w-full  flex items-center">
                <label
                  htmlFor="legalForm"
                  className="block font-bold mb-1  w-[22%]"
                >
                  <h2 className="text-gray-600">
                    Authoritative governmental instruments that the commitments
                    reference{" "}
                  </h2>
                </label>
                <textarea
                  id="countriesOfOperation"
                  name="countriesOfOperation"
                  placeholder="Enter a text"
                  className="mt-2 p-2 border mx-4 rounded-md w-[70%]"
                  // value={formData.countriesOfOperation}
                  // onChange={handleInputChange}
                  rows={4} // Specify the number of rows to determine the initial height
                />
              </div>
              <div className="my-4">
                <input
                  className="border-gray-300 rounded px-4 py-2 w-full text-xs"
                  type="file"
                  id="fileInput"
                  name="fileInput"
                />
              </div>
            </div>
            <div className="flex items-center mx-4 pb-2 mb-4">
              <div className="w-full flex items-center">
                <label
                  htmlFor="legalForm"
                  className="block font-bold mb-1 w-[22%]"
                >
                  <h2 className="text-gray-600">
                    Whether the commitments stipulate conducting due diligence
                  </h2>
                </label>
                <textarea
                  id="countriesOfOperation"
                  name="countriesOfOperation"
                  placeholder="Enter a text"
                  className="mt-2 p-2 border mx-4 rounded-md w-[70%]"
                  // value={formData.countriesOfOperation}
                  // onChange={handleInputChange}
                  rows={4} // Specify the number of rows to determine the initial height
                />
              </div>
              <div className="my-4">
                <input
                  className="border-gray-300 rounded px-4 py-2 w-full text-xs"
                  type="file"
                  id="fileInput"
                  name="fileInput"
                />
              </div>
            </div>
            <div className="flex items-center mx-4 pb-2 mb-4">
              <div className="w-full flex items-center">
                <label
                  htmlFor="legalForm"
                  className="block font-bold mb-1  w-[22%]"
                >
                  <h2 className="text-gray-600">
                    Whether the commitments stipulate applying the precautionary
                    principle{" "}
                  </h2>
                </label>
                <textarea
                  id="countriesOfOperation"
                  name="countriesOfOperation"
                  placeholder="Enter a text"
                  className="mt-2 p-2 border mx-4 rounded-md w-[70%]"
                  // value={formData.countriesOfOperation}
                  // onChange={handleInputChange}
                  rows={4} // Specify the number of rows to determine the initial height
                />
              </div>
              <div className="my-4">
                <input
                  className="border-gray-300 rounded px-4 py-2 w-full text-xs"
                  type="file"
                  id="fileInput"
                  name="fileInput"
                />
              </div>
            </div>
            <div className="flex items-center mx-4 pb-2 mb-4">
              <div className="w-full flex items-center">
                <label
                  htmlFor="legalForm"
                  className="block font-bold mb-1 w-[22%]"
                >
                  <h2 className="text-gray-600">
                    Whether the commitments stipulate respecting human rights{" "}
                  </h2>
                </label>
                <textarea
                  id="countriesOfOperation"
                  name="countriesOfOperation"
                  placeholder="Enter a text"
                  className="mt-2 p-2 border mx-4 rounded-md w-[70%]"
                  // value={formData.countriesOfOperation}
                  // onChange={handleInputChange}
                  rows={4} // Specify the number of rows to determine the initial height
                />
              </div>
              <div className="my-4">
                <input
                  className="border-gray-300 rounded px-4 py-2 w-full text-xs"
                  type="file"
                  id="fileInput"
                  name="fileInput"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="flex items-center mx-4 pb-2 mb-4">
          <div className="w-full mr-2">
            <label htmlFor="legalForm" className="block font-bold mb-1 pb-4">
              <h2 className="text-gray-600">
                Describe the specific policy commitment to respect human rights,
                including:
              </h2>
            </label>

            <div className="flex items-center mx-4 pb-2 mb-4">
              <div className="w-full  flex items-center">
                <label
                  htmlFor="legalForm"
                  className="block font-bold mb-1  w-[22%]"
                >
                  <h2 className="text-gray-600">
                    The internationally recognized human rights that the
                    commitment covers
                  </h2>
                </label>
                <textarea
                  id="countriesOfOperation"
                  name="countriesOfOperation"
                  placeholder="Enter a text"
                  className="mt-2 p-2 border mx-4 rounded-md w-[70%]"
                  // value={formData.countriesOfOperation}
                  // onChange={handleInputChange}
                  rows={4} // Specify the number of rows to determine the initial height
                />
              </div>
              <div className="my-4">
                <input
                  className="border-gray-300 rounded px-4 py-2 w-full text-xs"
                  type="file"
                  id="fileInput"
                  name="fileInput"
                />
              </div>
            </div>
            <div className="flex items-center mx-4 pb-2 mb-4">
              <div className="w-full flex items-center">
                <label
                  htmlFor="legalForm"
                  className="block font-bold mb-1 w-[22%]"
                >
                  <h2 className="text-gray-600">
                    The categories of stakeholders, including at-risk or
                    vulnerable groups, that the organization gives particular
                    attention to in the commitment
                  </h2>
                </label>
                <textarea
                  id="countriesOfOperation"
                  name="countriesOfOperation"
                  placeholder="Enter a text"
                  className="mt-2 p-2 border mx-4 rounded-md w-[70%]"
                  // value={formData.countriesOfOperation}
                  // onChange={handleInputChange}
                  rows={4} // Specify the number of rows to determine the initial height
                />
              </div>
              <div className="my-4">
                <input
                  className="border-gray-300 rounded px-4 py-2 w-full text-xs"
                  type="file"
                  id="fileInput"
                  name="fileInput"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="flex items-center mx-4 pb-2 mb-4">
          <div className="w-full mr-2">
            <label htmlFor="legalForm" className="block font-bold mb-1 pb-4">
              <h2 className="text-gray-600">
                Provide links to the policy commitments if publicly available,
                or, if the policy commitments are not publicly available,
                explain the reason for this
              </h2>
            </label>
            <input
              id="countriesOfOperation"
              name="countriesOfOperation"
              placeholder="Enter a text"
              className="mt-2 p-2 border rounded-md w-full"
              autoComplete="off"
              // value={formData.countriesOfOperation}
              // onChange={handleInputChange}
              rows={4} // Specify the number of rows to determine the initial height
            />
          </div>
        </div>
        <div className="flex items-center mx-4 pb-2 mb-4">
          <div className="w-full mr-2">
            <label htmlFor="legalForm" className="block font-bold mb-1 pb-4">
              <h2 className="text-gray-600">
                Report the level at which each of the policy commitments was
                approved within the organization, including whether this is the
                most senior level
              </h2>
            </label>
            <input
              id="countriesOfOperation"
              name="countriesOfOperation"
              placeholder="Enter a text"
              className="mt-2 p-2 border rounded-md w-full"
              autoComplete="off"
              // value={formData.countriesOfOperation}
              // onChange={handleInputChange}
              rows={4} // Specify the number of rows to determine the initial height
            />
          </div>
        </div>
        <div className="flex items-center mx-4 pb-2 mb-4">
          <div className="w-full mr-2">
            <label htmlFor="legalForm" className="block font-bold mb-1 pb-4">
              <h2 className="text-gray-600">
                Report the extent to which the policy commitments apply to the
                organization’s activities and to its business relationships
              </h2>
            </label>
            <input
              id="countriesOfOperation"
              name="countriesOfOperation"
              placeholder="Enter a text"
              className="mt-2 p-2 border rounded-md w-full"
              autoComplete="off"
              // value={formData.countriesOfOperation}
              // onChange={handleInputChange}
              rows={4} // Specify the number of rows to determine the initial height
            />
          </div>
        </div>
        <div className="flex items-center mx-4 pb-2 mb-4">
          <div className="w-full mr-2">
            <label htmlFor="legalForm" className="block font-bold mb-1 pb-4">
              <h2 className="text-gray-600">
                Describe how the policy commitments are communicated to workers,
                business partners, and other relevant parties.
              </h2>
            </label>
            <textarea
              id="countriesOfOperation"
              name="countriesOfOperation"
              placeholder="Enter a text"
              className="mt-2 p-2 border rounded-md w-full"
              autoComplete="off"
              // value={formData.countriesOfOperation}
              // onChange={handleInputChange}
              rows={4} // Specify the number of rows to determine the initial height
            />
          </div>
        </div>
      </form>
    </div>
  );
};

export default PolicyCommitments;
